import useRoutesControl from '../hooks/use-routes-control'

type Props = {
  loc: string
  children: JSX.Element
}

export default function RoutesWrapper({ loc, children }: Props) {
  useRoutesControl({ loc })
  return <>{children}</>
}
